import React, { useMemo } from 'react';

import { ChatIcon, Divider, IconWrapper, MailIcon, StateIndicatorWrapper } from './StateIndicator-styled-components';
import { CodeInputState } from './types';

interface StateIndicatorProps {
  codeInputState: CodeInputState;
  contactMethodsToVerify: CodeInputState[];
}

export const StateIndicator = ({ codeInputState, contactMethodsToVerify }: StateIndicatorProps) => {
  const isEmailState = codeInputState === CodeInputState.Email;

  const showEmailState = useMemo(() => contactMethodsToVerify.includes(CodeInputState.Email), [contactMethodsToVerify]);
  const showPhoneState = useMemo(() => contactMethodsToVerify.includes(CodeInputState.Phone), [contactMethodsToVerify]);
  const showDivider = useMemo(() => showPhoneState && showEmailState, [showPhoneState, showEmailState]);

  return (
    <StateIndicatorWrapper>
      {showPhoneState && (
        <IconWrapper $isActive>
          <ChatIcon $isActive />
        </IconWrapper>
      )}

      {showDivider && <Divider />}

      {showEmailState && (
        <IconWrapper $isActive={isEmailState}>
          <MailIcon $isActive={isEmailState} />
        </IconWrapper>
      )}
    </StateIndicatorWrapper>
  );
};
